import spartakSvg from 'materials/logos/spartak/spartak.svg';
import spartakPng from 'materials/logos/spartak/spartak.png';

import ukraineSvg from 'materials/logos/ukraine/ukraine.svg';
import ukrainePng from 'materials/logos/ukraine/ukraine.png';

import sgostuSvg from 'materials/logos/sgostu/sgostu.svg';
import sgostuPng from 'materials/logos/sgostu/sgostu.png';

import ephanPng from 'materials/logos/ephan/ephan.png';
import ephanDarkPng from 'materials/logos/ephan/dark.png';

import DDBDarkSvg from 'materials/logos/ddb/dark.svg';
import DDBDarkPng from 'materials/logos/ddb/dark.png';
import DDBLightSvg from 'materials/logos/ddb/DDB.svg';
import DDBLightPng from 'materials/logos/ddb/DDB.png';

import ndwLightsvg from 'materials/logos/ndw/light.svg';
import ndwLightpng from 'materials/logos/ndw/light.png';
import ndwDarksvg from 'materials/logos/ndw/dark.svg';
import ndwDarkpng from 'materials/logos/ndw/dark.png';

export const logos = [
  { name: 'СГОСТУ', svg: sgostuSvg, png: sgostuPng },
  { name: 'Ukraine', svg: ukraineSvg, png: ukrainePng },
  { name: 'Spartak', svg: spartakSvg, png: spartakPng },
  { name: 'DDB', svg: DDBLightSvg, png: DDBLightPng, svgDark: DDBDarkSvg, pngDark: DDBDarkPng },
  { name: 'E-phan', png: ephanPng, pngDark: ephanDarkPng },
  { name: 'New Dance Wave', svg: ndwLightsvg, png: ndwLightpng, svgDark: ndwDarksvg, pngDark: ndwDarkpng },
];
